/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вью попапа выбора причины отмены заявки
   */
  app.JPOrderCancellationView = app.FormView.extend({
    TYPES: ['participant', 'organizer'],
    PARTICIPANT_TYPE_ID: 1,
    ORGANIZER_TYPE_ID: 2,
    OTHER_TYPE_ID: 3,
    type: 'participant',

    el: '.js-cancellation-popup',
    formElement: '.js-cancellation-input',
    formName: 'cancellation-reason-form',

    events: {
      'click .js-submit': 'save',
    },

    run: function (options) {
      this.popupTemplate = app.helpers.TemplateHelper.getTemplate('#cancellation-reason-popup-template');

      if (options && options.type){
        this.type = options.type;
      }
      this._initReasons(this.type);
      this._initPopup();
      this.listenTo(Backbone, 'close-cancellation-popup', this.close);
    },

    close: function () {
      this.popup.close();
    },

    /**
     * Инициализация моделей причин отмены заявки
     * @param type {String} 'organizer' or 'participant'
     * @private
     */
    _initReasons: function (type) {
      this.allReasons = new app.CancellationReasons();

      this.reasonsModels = {
        organizer: new app.CancellationReasons(),
        participant: new app.CancellationReasons()
      };
      this.reasons = this.reasonsModels[type];
      var that = this;
      this.listenToOnce(this.allReasons, 'sync', function () {
        that.reasonsModels.participant.set(
          'items',
          _.filter(that.allReasons.get('items'), function (reason) {
            return reason.type === that.PARTICIPANT_TYPE_ID || reason.type === that.OTHER_TYPE_ID;
          })
        );
        that.reasonsModels.organizer.set(
          'items',
          _.filter(that.allReasons.get('items'), function (reason) {
            return reason.type === that.ORGANIZER_TYPE_ID || reason.type === that.OTHER_TYPE_ID;
          })
        );
        that.render();
      });

      this.allReasons.fetch();
    },

    /**
     * Инициализация попапа
     * @private
     */
    _initPopup: function () {
      if (this.model instanceof app.Model) {
        this.popup = new als.Popup(this.$el, $('.js-open-cancellation-popup[data-order-id=' + this.model.get('id') + ']'));
        this.popup.addEventListener(als.Popup.EventType.BEFORE_OPEN, function (jqEvent, event) {
          var orderId = (event && event.target) ? event.target.data('orderId') : null;
          var type = (event && event.target) ? event.target.data('orderOrganizer') : null;
          this._setType(type);
          this._setPosition($(event.target));
          this.$('.js-submit').data('order-id', event.target.data('order-id'));
          if (orderId) {
            this.model = this._setJpModel({
              id: orderId,
            });
          }
        }.bind(this));
      }
    },

    /**
     * Обновление информации в попапе
     */
    render: function () {
      this.$('.js-container').html(this.popupTemplate({
        reasons: this.reasons ? this.reasons.get('items') : false
      }));
      this.updateFieldsList();
    },

    /**
     * Собираем информацию об отмене и передаем в модель jp-order для отмены
     */
    save: function (event) {
      if (event instanceof jQuery.Event) {
        var $cancelButton = $(event.target);
        if (this.model instanceof app.Model && $cancelButton.data('order-id') === this.model.get('id')) {
          var data = this.getData();
          this.model.cancelJPOrder(data, {
            error: this.error.bind(this),
            success: this.success.bind(this),
            userType: this.type
          });
        }
      }
    },

    success: function (model) {
      this.trigger('cancellation-popup:success', model);

      /**
       * Удаляем сохраненную модель из коллекции
       */
      if (this.collection && this.collection.length){
        var order = this.collection.findWhere({
          id: model.id
        });
        order.trigger('order-cancellation:remove-view');
        this.collection.remove(order);
      }
      /**
       * Если в коллекции остались модели, пробуем удалить первую,
       * если коллекция пустая, закрываем попап
       */
      if (this.collection && this.collection.length){
        this.model = this._setJpModel(this.collection.at(0));
        this.save();
      } else {
        this.popup.close();
      }
    },

    /**
     * Показать попап
     * @param opener {jQuery} объект, при клике на который был открыт попап
     * @param options {Object} опции
     */
    show: function (opener, options) {
      var that = this,
        model;

      this.model = null;
      this.collection = null;

      if (options && options.model) {
        model = options.model;
      }
      if (options && options.type){
        this._setType(options.type);
      }

      /**
       * Если модель в опциях является моделью, сохраняем ссылку на нее в this.model
       */
      if (model instanceof app.Model){
        this.model = this._setJpModel(model);
      }
      /**
       * Если модель в опциях является коллекцией, сохраняем ссылку на нее в this.collection,
       * в this.model сохраняем первую модель коллекции
       */
      if (model instanceof app.Collection){
        this.collection = model;
        this.model = this._setJpModel(this.collection.at(0));
      }

      setTimeout(function () {
        that.popup.open(opener);
      }, 0);
      this._setPosition(opener);
    },

    /**
     * Возвращаем новую модель app.JpOrder с айди полученной модели
     * @param orderModel
     * @returns {*}
     */
    _setJpModel: function (orderModel) {
      return new app.JpOrder({
        id: orderModel.id
      });
    },

    /**
     * Меняем тип попапа
     * @param type {String} 'organizer' or 'participant'
     */
    _setType: function (type) {
      if (!_.includes(this.TYPES, type)){
        return;
      }
      /**
       * Если тип поменялся, меняем модель в this.reasons и перерисовываем список причин
       */
      if (this.type !== type){
        this.type = type;
        this.reasons = this.reasonsModels[type];
        this.render();
      }
    },

    /**
     * Позиционируем попап к кнопке, с помощью которой он был открыт
     * @param opener {jQuery}
     */
    _setPosition: function (opener) {
      var initiatorOffset = opener.length ? opener.offset() : null,
        body = $('body'),
        bodyPosition = body.position(),
        left = (initiatorOffset ? initiatorOffset.left : 0) - bodyPosition.left - 75,
        top = (initiatorOffset ? initiatorOffset.top : 0) - bodyPosition.top + opener.height() + 30,
        newCss = {
          top: top,
          display: 'block'
        },
        bodyWidth = body.width(),
        popupPosition = this.$el.outerWidth() + left;

      /**
       * На маленьких разрешениях позиционируем по правому краю
       */
      if (bodyWidth < popupPosition){
        newCss.right = '1.4em';
        this.$('.corner-arrow').addClass('corner-arrow-right');
      } else {
        newCss.left = left;
        this.$('.corner-arrow').removeClass('corner-arrow-right');
      }
      this.$el.css(newCss);
    }
  });
})(jQuery);

}.call(window));